import React, {useEffect, useState} from 'react'
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileUpload from "../../../FileUploads/FileUpload";
import NewFileUploader from '../../../NewFileUploader/NewFileUploader.js';

const Edit = ({
                  match,
                  history,
                  documentUploadUrlPublic,
                  documentUrlDataPublic,
                  ucdById,
                  ucdDetails = [],
                  ucdUpdate,
                  ucsUpdateResponse = [],
                  newBankDetailsRequest,
                  newBankDetailsResponse = []
              }) => {
    const [inputList, setInputList] = useState([{
        msme_certificate: '',
        bank_name: '',
        account_no: '',
        ifsc_code: '',
        branch_name: '',
        upload_cancelled_cheque: '',
        selfie_with_dsa: '',
        dealer_images_1: '',
        dealer_images_2: '',
        dealer_images_3: '',
        dealer_images_4: '',
        gst_certificate_photo: '',
        pan_card_photo: '',
        msme_declaration_photo: '',
        msme_certificate_photo: '',
        gst_registration: '',
        account_type: '',
        msme_no: '',
        office_location: '',
        current_location: ''
    }]);

    const [isLoading, setIsLoading] = useState(false)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);
    const [customerBankName, setCustomerBankName] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await ucdById(match?.params?.id)
            await newBankDetailsRequest();
            setIsLoading(false)
        })()
    }, [])

    const handleInput = (val, index) => {
        const list = [...inputList]
        list[0][index] = val
        setInputList(list)
    }


    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        if (parseInt(ucsUpdateResponse?.status) === 200) {
            toast.success(ucsUpdateResponse?.message)
            setTimeout(() => {
                window.location.href = 'ucd-dealer-list'
            }, 1000)
        } else if (ucsUpdateResponse?.status !== undefined && ucsUpdateResponse?.status !== 200) {
            toast.error(ucsUpdateResponse?.message)
            setDisableSubmitButton(false)
        }
    }, [ucsUpdateResponse])


    const handleSubmit = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0]
        requestParams['lat'] = islatlng?.lat
        requestParams['long'] = islatlng?.lng
        requestParams['id'] = match?.params?.id


        if (ucdDetails?.data && ucdDetails?.data?.channel_type === 'DSA' && !requestParams['selfie_with_dsa']) {
            toast.error("Selfie is required with DSA")
            return false;
        } else if (ucdDetails?.data?.channel_type !== 'DSA' &&
            (
                !requestParams['dealer_images_1'] ||
                !requestParams['dealer_images_2'] ||
                !requestParams['dealer_images_3'] ||
                !requestParams['dealer_images_4']
            )
        ) {
            toast.error("Please upload all 4 dealer images.");
            return false;
        }


        if(requestParams['bank_name'] === 'Other'){
            requestParams['bank_name'] =  customerBankName;
        }

        if (!requestParams['gst_certificate_photo'] && ucdDetails?.data?.organization_type === 'Company') {
            toast.error("GST certificate photo is missing.")
            return false;
        }

        if (!requestParams['pan_card_photo']) {
            toast.error("Pan card photo is missing.")
            return false;
        }

        if (!requestParams['msme_declaration_photo'] && !requestParams['msme_certificate_photo']) {
            toast.error("MSME declaration or certificate photo is missing.")
            return false;
        }

        // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
        if (requestParams['lat'] == null || requestParams['long'] == null) {
            toast.error('Please enable your location');
            return false
        }

        setIsLoading(true)
        setDisableSubmitButton(true)
        await ucdUpdate(requestParams)
        setIsLoading(false)
    }


    useEffect(() => {
        if (ucdDetails?.data) {
            handleInput(ucdDetails?.data?.bank_name, 'bank_name')
            handleInput(ucdDetails?.data?.account_no, 'account_no')
            handleInput(ucdDetails?.data?.branch_name, 'branch_name')
            handleInput(ucdDetails?.data?.ifsc_code, 'ifsc_code')
            handleInput(ucdDetails?.data?.upload_cancelled_cheque, 'upload_cancelled_cheque')
            handleInput(ucdDetails?.data?.selfie_with_dsa, 'selfie_with_dsa')
            handleInput(ucdDetails?.data?.dealer_images_1, 'dealer_images_1')
            handleInput(ucdDetails?.data?.dealer_images_2, 'dealer_images_2')
            handleInput(ucdDetails?.data?.dealer_images_3, 'dealer_images_3')
            handleInput(ucdDetails?.data?.dealer_images_4, 'dealer_images_4')
            handleInput(ucdDetails?.data?.gst_certificate_photo, 'gst_certificate_photo')
            handleInput(ucdDetails?.data?.pan_card_photo, 'pan_card_photo')
            handleInput(ucdDetails?.data?.msme_declaration_photo, 'msme_declaration_photo')
            handleInput(ucdDetails?.data?.msme_certificate_photo, 'msme_certificate_photo')
            handleInput(ucdDetails?.data?.account_type, 'account_type')
            handleInput(ucdDetails?.data?.gst_registration, 'gst_registration')
            handleInput(ucdDetails?.data?.msme_certificate, 'msme_certificate')
            handleInput(ucdDetails?.data?.office_location, 'office_location')
            handleInput(ucdDetails?.data?.current_location, 'current_location')
        }

        let isMatch = false;
        newBankDetailsResponse.map(val => {
            if(val.id === ucdDetails?.data?.bank_name){
                isMatch = true;
            }
        })

        if(!isMatch){
            handleInput("Other", 'bank_name')
            setCustomerBankName(ucdDetails?.data?.bank_name)
        }
    }, [ucdDetails, newBankDetailsResponse])

    useEffect(() => {

    }, [newBankDetailsResponse]);

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Dealer Details'}
                            history={history}
                        />
                        {/*BODY*/}
                        <div>
                            <div className="container-fluid">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                                            </div>
                                            <div className="mb-4 bg-white"> {/*card*/}
                                                <div className="hide card-header bg-lightGreen-active">
                                                    POC Details
                                                </div>
                                                <div className="card-body">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={ucdDetails?.data?.business_name}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Business Name
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={ucdDetails?.data?.owner_name}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Owner Name
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={ucdDetails?.data?.dealer_pan_no}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Dealer Pan No
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="number"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={ucdDetails?.data?.aadhar_no}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Aadhar No
                                                                </label>
                                                            </div>
                                                            {ucdDetails?.data && ucdDetails?.data?.firm_name &&
                                                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           value={ucdDetails?.data?.firm_name}
                                                                           disabled={true}
                                                                    />
                                                                    <label
                                                                        className="large-label float-lb">
                                                                        Firm Type
                                                                    </label>
                                                                </div>
                                                            }
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={ucdDetails?.data?.gst_registration}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    GST Registration
                                                                </label>
                                                            </div>

                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'gst_no', e)
                                                                       }}
                                                                       value={ucdDetails?.data?.dealer_gst_no}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    GST No
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input 
                                                                    type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    // value={ucdDetails?.data?.current_location}
                                                                    value={inputList[0]?.current_location}
                                                                    onChange={(e) => {                                                                     
                                                                        handleInput(e.target.value, 'current_location')
                                                                    }}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Registration Address
                                                                </label>
                                                            </div>
                                                            {inputList[0]?.office_location &&
                                                                <div
                                                                    className="col-sm-6 col-md-3 mt-1 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           value={inputList[0]?.office_location}
                                                                            onChange={(e) => {
                                                                                handleInput(e.target.value, 'office_location', e)
                                                                            }}
                                                                    />
                                                                    <label
                                                                        className="large-label float-lb">
                                                                        Office Address
                                                                    </label>
                                                                </div>
                                                            }

                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={ucdDetails?.data?.msme_certificate}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                MSME Certificate
                                                                </label>
                                                            </div>


                                                            {ucdDetails?.data?.msme_certificate === 'Yes' &&
                                                                <div
                                                                    className="col-sm-6 col-md-3 mt-1 float-field">
                                                                    <input type="number"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           value={ucdDetails?.data?.msme_no}
                                                                           disabled={true}
                                                                    />
                                                                    <label
                                                                        className="large-label float-lb">
                                                                        MSME No <i
                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                            }
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="email"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={ucdDetails?.data?.registration_email}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Dealer Email Id
                                                                </label>
                                                            </div>

                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={ucdDetails?.data?.registration_mobile_no}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Registration Phone No
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 mt-1 float-field"
                                                                style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput(e.target.value, 'bank_name')
                                                                    }}>
                                                                    <option value="">Bank Name
                                                                    </option>
                                                                    {newBankDetailsResponse.map(val => {
                                                                        return (
                                                                            <>
                                                                                <option
                                                                                    value={val?.id}
                                                                                    selected={inputList[0]?.bank_name === val?.id}>{val?.id}</option>
                                                                            </>
                                                                        )
                                                                    })}

                                                                </select>
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Bank Name
                                                                    <i
                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            {inputList[0]?.bank_name === 'Other' &&
                                                                <div
                                                                    className="col-sm-6 col-md-3 mt-1 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               setCustomerBankName(e.target.value)
                                                                           }}
                                                                           value={customerBankName}
                                                                           required={true}
                                                                    />
                                                                    <label
                                                                        className="large-label float-lb">
                                                                        Bank Name <i
                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                            }
                                                            {/*<div*/}
                                                            {/*    className="col-sm-6 col-md-3 mt-1 float-field">*/}
                                                            {/*    <input type="text"*/}
                                                            {/*           className="form-control form-control-user"*/}
                                                            {/*           placeholder=" "*/}
                                                            {/*           onChange={(e) => {*/}
                                                            {/*               handleInput(e.target.value, 'bank_name')*/}
                                                            {/*           }}*/}
                                                            {/*           value={inputList[0]?.bank_name}*/}
                                                            {/*    />*/}
                                                            {/*    <label*/}
                                                            {/*        className="large-label float-lb">*/}
                                                            {/*        Bank Name <i*/}
                                                            {/*        className="bi bi-asterisk astrick-icon"></i>*/}
                                                            {/*    </label>*/}
                                                            {/*</div>*/}

                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="number"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                                                           handleInput(e.target.value, 'account_no');
                                                                           e.target.value = value;
                                                                       }}
                                                                       value={inputList[0]?.account_no}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Bank Account No <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput(e.target.value, 'account_type')
                                                                    }} required>
                                                                    <option value="">Account Type</option>
                                                                    <option
                                                                        value="Savings"
                                                                        selected={inputList[0]?.account_type === 'Savings'}>Saving
                                                                    </option>
                                                                    <option
                                                                        value="Current"
                                                                        selected={inputList[0]?.account_type === 'Current'}>Current
                                                                    </option>

                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Account Type
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'ifsc_code')
                                                                       }}
                                                                       value={inputList[0]?.ifsc_code}
                                                                       maxlength={11}
                                                                       minlength={11}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    IFSC Code <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'branch_name')
                                                                       }}
                                                                       value={inputList[0]?.branch_name}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Branch Name <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 float-field  mb-3">
                                                                <FileUpload
                                                                    id={`addAttachment`}
                                                                    accept=".png,.jpg,.jpeg"
                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                    documentUrlData={documentUrlDataPublic}
                                                                    onChange={(val) => {
                                                                        handleInput(val, 'upload_cancelled_cheque')
                                                                    }}
                                                                    required={true}
                                                                    prefilledFilename={inputList[0]['upload_cancelled_cheque'] ? "Cancelled Cheque" : ""}
                                                                >
                                                                    Upload Cancelled Cheque
                                                                </FileUpload>
                                                            </div>
                                                            {ucdDetails?.data && ucdDetails?.data?.channel_type === 'DSA' ?
                                                                <div className="col-sm-6 float-field mb-3">
                                                                    <FileUpload
                                                                        id={`addAttachment`}
                                                                        accept=".png,.jpg,.jpeg"
                                                                        documentUploadUrl={documentUploadUrlPublic}
                                                                        documentUrlData={documentUrlDataPublic}
                                                                        onChange={(val) => {
                                                                            handleInput(val, 'selfie_with_dsa')
                                                                        }}
                                                                        required={true}
                                                                        prefilledFilename={inputList[0]['selfie_with_dsa'] ? "Selfie with DSA" : ""}
                                                                        multiple={true}
                                                                    >
                                                                        Selfie with DSA
                                                                    </FileUpload>
                                                                </div>
                                                                :
                                                                <>
                                                                <div className='col-md-6 mb-4'>
                                                                    <span style={{fontWeight: "bold"}}>
                                                                    Dealership Images (Min. 4)
                                                                    <span style={{ color: "darkred" }}>*</span>
                                                                    </span>

                                                                    <div className="d-flex mt-3" style={{ gap: "10px" }}>
                                                                    {[1, 2, 3, 4].map((num) => (
                                                                        <NewFileUploader
                                                                        key={num}
                                                                        id={`dealer_images_${num}`}
                                                                        label={
                                                                                <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                                                <i className="bi bi-upload"></i> {num}
                                                                                </span>
                                                                            }
                                                                        accept=".png,.jpg,.jpeg,.pdf,.doc"
                                                                        name={`dealer_images_${num}`}
                                                                        documentUploadUrl={documentUploadUrlPublic}
                                                                        documentUrlData={documentUrlDataPublic}
                                                                        onChange={(val) => {
                                                                            handleInput(val, `dealer_images_${num}`);
                                                                        }}
                                                                        value={inputList[0]?.[`dealer_images_${num}`]}
                                                                        />
                                                                    ))}

                                                                    </div>
                                                                </div>
                                                                </>
                                                            }

                                                            <div className="col-sm-6 float-field mb-3">
                                                                <FileUpload
                                                                    id={`addAttachment`}
                                                                    accept=".png,.jpg,.jpeg"
                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                    documentUrlData={documentUrlDataPublic}
                                                                    onChange={(val) => {
                                                                        handleInput(val, 'gst_certificate_photo')
                                                                    }}
                                                                    required={(ucdDetails?.data && ucdDetails?.data?.organization_type === 'Company') || inputList[0]?.gst_registration === 'Yes'}
                                                                    prefilledFilename={inputList[0]['gst_certificate_photo'] ? "GST Certificate" : ""}
                                                                >
                                                                    Upload GST Certificate
                                                                </FileUpload>
                                                            </div>
                                                            <div className="col-sm-6 float-field mb-3">
                                                                <FileUpload
                                                                    id={`addAttachment`}
                                                                    accept=".png,.jpg,.jpeg"
                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                    documentUrlData={documentUrlDataPublic}
                                                                    onChange={(val) => {
                                                                        handleInput(val, 'pan_card_photo')
                                                                    }}
                                                                    required={true}
                                                                    prefilledFilename={inputList[0]['pan_card_photo'] ? "PAN Card" : ""}
                                                                >
                                                                    Upload PAN Card
                                                                </FileUpload>
                                                            </div>
                                                            {ucdDetails?.data?.msme_certificate === 'Yes' ?
                                                                <div className="col-sm-6 float-field mb-3">
                                                                    <FileUpload
                                                                        id={`addAttachment`}
                                                                        accept=".png,.jpg,.jpeg"
                                                                        documentUploadUrl={documentUploadUrlPublic}
                                                                        documentUrlData={documentUrlDataPublic}
                                                                        onChange={(val) => {
                                                                            handleInput(val, 'msme_certificate_photo')
                                                                        }}
                                                                        required={true}
                                                                        prefilledFilename={ucdDetails?.data?.msme_certificate_photo ? "MSME Certificate" : ""}
                                                                    >
                                                                        MSME Certificate
                                                                    </FileUpload>
                                                                </div>
                                                                :
                                                                <div className="col-sm-6 float-field mb-3">
                                                                    <FileUpload
                                                                        id={`addAttachment`}
                                                                        accept=".png,.jpg,.jpeg"
                                                                        documentUploadUrl={documentUploadUrlPublic}
                                                                        documentUrlData={documentUrlDataPublic}
                                                                        onChange={(val) => {
                                                                            handleInput(val, 'msme_declaration_photo')
                                                                        }}
                                                                        required={true}
                                                                        prefilledFilename={inputList[0]['msme_declaration_photo'] ? "MSME Declaration" : ""}
                                                                    >
                                                                        MSME Declaration
                                                                    </FileUpload>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <button className="btn btn-primary btn-user btn-block submit-btn"
                                                        disabled={disableSubmitButton}>
                                                    Submit Details
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default Edit